import Spinner from "@/components/base/Spinner.tsx";
import { useStore } from "@/stores/useStore.ts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const HomePage = () => {
  const navigate = useNavigate();
  const tenantId = useStore((s) => s.tenant?.id);
  const allowedTenants = useStore((s) => s.allowedTenants);
  const initialized = useStore((s) => s.initialized);

  useEffect(() => {
    if (tenantId) {
      navigate(`/app/${tenantId}`);
    } else if (allowedTenants && allowedTenants.length > 0) {
      navigate(`/app/${allowedTenants[0].id}`);
    }
  }, [tenantId, allowedTenants]);

  useEffect(() => {
    if (initialized && allowedTenants && allowedTenants.length === 0) {
      navigate("/setup");
    }
  }, [allowedTenants, initialized]);

  return (
    <div className="flex flex-grow items-center justify-center">
      <Spinner />
    </div>
  );
};
